import { render, staticRenderFns } from "./IndustryAccidentList.vue?vue&type=template&id=a9e4ebb4&scoped=true&"
import script from "./IndustryAccidentList.vue?vue&type=script&lang=js&"
export * from "./IndustryAccidentList.vue?vue&type=script&lang=js&"
import style0 from "./IndustryAccidentList.vue?vue&type=style&index=0&id=a9e4ebb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e4ebb4",
  null
  
)

export default component.exports